module.exports = __webpack_public_path__ + "img/0-02-0a-5eceb04df889318b2e7b589f9374e116dc9a2af83cfc35973677a18d73045089_3201f5a6.8e04e92f.jpg";